import { Container } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { ReactComponent as PendingReview } from "assets/svg/pending-review.svg";
import { useUser } from "contexts/UserContext";
import styles from "./styles.module.scss";

const PendingReviewNonAMHC = () => {
  const { user } = useUser();

  return (
    <div className={styles["pending-review"]}>
      <Container className={styles["pending-review__container"]}>
        <h4 className={styles["pending-review__title"]}>
          Welcome to Orchid{`, ${user?.first_name}`}!
        </h4>

        <div className={styles["pending-review__section-1"]}>
          <p>We're thrilled to have you here.</p>
          <p>
            Your profile is currently under review to ensure the professional
            standard of our community. This process typically takes between 1-2
            business days.
          </p>
          <p>
            In the meantime, we're here to help! If you have any questions or
            need assistance, please don't hesitate to email us at
            <a href="mailto:info@orchid.health"> info@orchid.health</a>.
          </p>
        </div>

        <div className={styles["pending-review__section-2"]}>
          Alternatively, seize the moment to become acquainted with all that
          Orchid has to offer by scheduling a 20-minute personalized walkthrough
          with a live Orchid team member.
        </div>
        <div className={styles["pending-review__action"]}>
          <Button
            as={"a"}
            target="_blank"
            rel="noopener noreferrer"
            href={"https://calendly.com/hey-orchid/orchid-walkthrough"}
          >
            Schedule Walkthrough
          </Button>
        </div>
        <div className={styles["pending-review__footer-section"]}>
          <div className={"rg-16"}>Warm regards, </div>
          <div className={"rg-16 deep-blue"}>The Orchid Team</div>
        </div>
      </Container>
      <PendingReview />
    </div>
  );
};

export default PendingReviewNonAMHC;
